import React, { useEffect, useMemo } from 'react';
import Back from '../../../features/back/Back';
import { taskContent, taskScrollSettings } from '../../../../constants/copyright';
import { useContent } from '../../../../redux/reducer/content';
import TaskItem from '../TaskItem/TaskItem';
import useStateControls from '../../../../hooks/useStateControls';
import { useRequests } from '../../../../redux/reducer/requests';
import { useFormattedTasks } from '../../../../hooks/useFormattedTasks';
import AppLoader from '../../../features/appLoader/AppLoader';
import Toggle from '../../../baseComponents/gui/toggle/Toggle';
import { useAccountMode } from '../../../../hooks/useAccountMode';
import { PremiumOffer } from '../PremiumOffer/PremiumOffer';
import { Scrollbar } from 'react-scrollbars-custom';
import { useCheckOnCompleteSomeQuests } from '../../../../hooks/useCheckOnCompleteSomeQuests';
import { useGetPrizeFromQuest } from '../../../../hooks/useGetPrizeFromQuest';
import { useTranslation } from '../../../../translations';

const Task = React.forwardRef(
  /**
   * @param {{ callbacks: ApplicationCallbacks }} props
   * @param {import("react").Ref<HTMLDivElement>} ref
   */
  function Task({ callbacks }, ref) {
    const { t } = useTranslation();
    const {
      authData: { isWeb },
    } = useRequests();
    const { title, filterList, formattedTasksDefault } = taskContent;
    const { activeTasksSection } = useContent();
    const { setState } = useStateControls();
    const formattedTasks = useFormattedTasks();

    const { mode: accountMode } = useAccountMode();

    const tasksCallbacks = useMemo(
      () =>
        Object.keys(formattedTasks).reduce(
          (acc, key) => ({
            ...acc,
            [key]: () => callbacks?.setActiveTasksSection(key),
          }),
          {},
        ),
      [formattedTasks],
    );

    const necessaryTasks = useMemo(
      () => formattedTasks?.[activeTasksSection]?.list ?? [],
      [formattedTasks, activeTasksSection],
    );

    const startActive = useMemo(
      () =>
        Object.entries(formattedTasksDefault)
          .reduce((acc, [key, value]) => {
            acc[value.order] = key;
            return acc;
          }, [])
          .indexOf(activeTasksSection),
      [activeTasksSection],
    );

    const isPending = useGetPrizeFromQuest({ callbacks });

    useEffect(() => {
      callbacks.getQuests();
    }, []);

    useCheckOnCompleteSomeQuests({ callbacks });

    return (
      <section className={`task ${isWeb ? '' : 'app'}`} ref={ref}>
        <div className={`task__header`}>
          <Back onClick={() => setState('main')} />
          <h1 className={'task__title'}>{t(title)}</h1>
        </div>
        <div className={'task__content'}>
          <div className={'task__toggle-wrapper'}>
            <Scrollbar {...taskScrollSettings}>
              <Toggle
                list={filterList.map((item) => ({ ...item, text: t(item.text) }))}
                funcs={tasksCallbacks}
                mod={'wide'}
                startActive={startActive}
              />
            </Scrollbar>
          </div>

          {{ standard: <PremiumOffer callbacks={callbacks} /> }[accountMode]}

          <ul className={'task__list'}>
            {necessaryTasks.map((el, index) => (
              <TaskItem key={`task-item-${el.id}`} callbacks={callbacks} index={index} quest={el} />
            ))}
          </ul>
        </div>

        {isPending && <AppLoader />}
      </section>
    );
  },
);
export default Task;
Task.propTypes = {};
